import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import { MergeData } from '../_models/doc-editor.model';

@Injectable({
  providedIn: 'root'
})
export class DocEditorService {
  private baseURL = `${environment.apiUrl}/api`;
  private midURL = '/documenteditor';
  private SAVE_DOC_URL = '/docsave';
  private SAVE_TEMPLATE_DOC_URL = '/templatesave';
  private MERGE_DOC_URL = '/mergedoc';
  
  public get getSaveDocUrl() {
    return `${this.baseURL}${this.midURL}${this.SAVE_DOC_URL}`;
  }

  public get getSaveTemplateUrl() {
    return `${this.baseURL}${this.midURL}${this.SAVE_TEMPLATE_DOC_URL}`;
  }

  public get getMergeDocUrl() {
    return `${this.baseURL}${this.midURL}${this.MERGE_DOC_URL}`;
  }

  constructor(private http: HttpClient) {}

  /**
   * Save Document
   */
  saveDoc = (fd: any): Observable<any> => {
    return this.http.post(`${this.getSaveDocUrl}`, fd);
  };

  /**
   * Save Template
   */
  saveTemplate = (fd: any): Observable<any> => {
    return this.http.post(`${this.getSaveTemplateUrl}`, fd);
  };

  mergeDoc = (data: MergeData): Observable<any> => {
    return this.http.post(`${this.getMergeDocUrl}`, data);
  }
}
